export default {
  get_items_list: (state) => state.shipmentContentItems.items,
  get_items_count: (state) => state.shipmentContentItems.count,
  get_item: (state) => state.shipmentContentItem,
};
